module.exports = __webpack_public_path__ + "static/media/head-shot.b3229bec.svg";